import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'src/app/shared/shared.module';
import { VouchersComponent } from './components/vouchers/vouchers.component';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

@NgModule({
  declarations: [VouchersComponent],
  exports: [VouchersComponent],
  imports: [CommonModule, FormsModule, SharedModule, NgbModule, FGBSharedModule],
})
export class VouchersModule {}
